


































import Logo from '@/assets/img/logo-login.svg';

import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { UserState } from '@/store/user/types';
import { ActionError as userStoreErr } from '@/store/user/types';

import { login as loginFeedback, logout as logoutFeedback, refresh as REFRESH, checkUserInfo as CHECK_USER_INFO, checkApiTokenHeader as CHECK_OWN_API_AUTH_DEFAULT } from '@/const/terms/feedback/user';

import { SET_EXTERNAL_API_DEFAULT } from '@/utils/api';
import {ERROR as apiErr} from '@/utils/api/types';

import {
    LoginInputType,
    LoginRuleType,
} from './types';

import { Form as ElForm } from 'element-ui';

@Component<Login>({
    name: 'Login',
})
export default class Login extends Vue {
    // data
    private bgImgs: string[] = [
        require('@/assets/background/bg-01.jpg'), require('@/assets/background/bg-02.jpg'),
        require('@/assets/background/bg-03.jpg'), require('@/assets/background/bg-04.jpg'),
        require('@/assets/background/bg-05.jpg'), require('@/assets/background/bg-06.jpg'),
        require('@/assets/background/bg-07.jpg'), require('@/assets/background/bg-08.jpg'),
        require('@/assets/background/bg-09.jpg'), require('@/assets/background/bg-10.jpg'),
    ];
    private bgIdx: number = 0;
    private Logo: string = Logo;
    private input: LoginInputType = { email: '', password: '', keepLogin: true };
    private loginRule: LoginRuleType = {
        email: [{ required: true, message: loginFeedback.rule.email.required, trigger: 'blur' }],
        password: [{ required: true, message: loginFeedback.rule.password.required, trigger: 'blur' }],
    };
    private loading: boolean = false;

    // vuex
    @Action('User/LOGIN') private login: any;
    @Action('User/LOGOUT') private logout: any;
    @State('User') private user!: UserState
    // methods
    public loginHandler() {
        this.loading = true;
        const form = this.$refs.loginForm as ElForm;
        return form.validate().then(async (valid) => {
            if (valid) {
                try {
                    await this.login(this.input);
                } catch(err) {
                    try {
                        await this.logout();
                    } catch (logoutError) {
                        this.$notify.error(logoutFeedback.error.withLogin);
                        throw logoutError;
                    }
                    throw err;
                }
                
                const returnURL = (window.location.search.match(new RegExp('[?&]returnURL=([^&]+)')) || [, null])[1];
                if (returnURL) {
                    this.$router.push({ path: decodeURIComponent(returnURL as string) });
                } else {
                    this.$router.push({ name: 'root' });
                }

            } else {
                this.$notify.warning({ message: loginFeedback.error.invalidInput, title: loginFeedback.error.title });
            }
        })
        .catch( (err) => {
            if (err === false) {
                const errorField = (form as any).fields.find((f: any) => f.validateState === 'error') as Vue;
                if (errorField) {
                    const el = errorField.$el.querySelector('input') as HTMLElement;
                    el.focus();
                }
                return;
            }
            switch (err.type) {
                case userStoreErr.HTTP_LOGIN_RESPONSE_NOT_FOUND :
                    this.$notify.error({ message: loginFeedback.error.notRegistered, title: loginFeedback.error.title });
                    return;
                    break;
                case userStoreErr.HTTP_LOGIN_RESPONSE_NOT_MATCHED :
                    this.$notify.error({ message: loginFeedback.error.notMatched, title: loginFeedback.error.title });
                    return;
                    break;
                case apiErr.HTTP_API_DEFAULT:
                    Vue.prototype.$notify.error({message: CHECK_USER_INFO.error.fail, title: CHECK_USER_INFO.error.title});
                    Vue.prototype.customRouterErrorHandler(err, 'twAPI/infos/customers FATAL ERROR');
                    return;
                    break;
                case apiErr.SET_EXTERNAL_API_DEFAULT:
                        Vue.prototype.$notify.error({message: CHECK_USER_INFO.error.setFail, title: CHECK_USER_INFO.error.setFailTitle});
                        Vue.prototype.customRouterErrorHandler(err, 'API Default params setting fail FATAL ERROR');
                    return;
                    break;
                case userStoreErr.VUEX_SET_USER :
                default:
                    this.$notify.error({ message: loginFeedback.error.fail, title: loginFeedback.error.title });
            }
            throw err;
        })
        .finally(() => {
            this.loading = false;
        });
    }


    // lifecycles
    public created(): void {
        this.bgIdx = Math.floor(Math.random() * 10 % 10);
    }
}

